<template>
  <div v-if="get_loading" class="intercom-loading">
    <svg class="intercom-loading__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#0057FF" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" /></svg>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'IntercomLoading',
  computed: {
    ...mapGetters('intercom', ['get_loading']),
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
